import { h } from 'preact';
import type { TermEntry } from '../../types/mentioned-terms';
import { Checkmark } from '../icons/checkmark';
import * as styles from './more-items.dropdown.scss';

interface Props {
  terms: TermEntry[];
  activeTerm: string | null;
  onTermClick: (term: string) => void;
}
export const MoreItemsDropdown = ({ terms, onTermClick, activeTerm }: Props): h.JSX.Element => {
  function handleKeyDown(e: KeyboardEvent, term: string): void {
    if (e.key === ' ') {
      onTermClick(term);
    }
  }

  return (
    <ul className={styles.menuContainer} role="menu">
      {terms.map((term) => {
        const [termText, termCount] = term;
        return (
          <div key={termText} className={styles.menuItemContainer}>
            <li
              className={styles.menuItem}
              role="menuitem"
              tabIndex={0}
              onClick={() => {
                onTermClick(termText);
              }}
              onKeyDown={(e) => handleKeyDown(e, termText)}
            >
              <span>{`${termText} (${termCount})`}</span>
              <span className={styles.checkmark}>{activeTerm?.toLowerCase() === termText.toLowerCase() ? <Checkmark /> : null}</span>
            </li>
          </div>
        );
      })}
    </ul>
  );
};
